export function selectPreviousFlightCard({
  postFlightBacklog = [],
  completedBooking = null,
} = {}) {
  const latestPostFlightBooking =
    postFlightBacklog[0] || null;

  if (latestPostFlightBooking) {
    return {
      status: 'requires_closure',
      booking:
        latestPostFlightBooking,
    };
  }

  if (completedBooking) {
    return {
      status: 'completed',
      booking: completedBooking,
    };
  }

  return {
    status: 'empty',
    booking: null,
  };
}
